module.exports = __webpack_public_path__ + "img/modulo_Name.68f6c4c.svg";